module.exports = __webpack_public_path__ + "static/media/surveillance_purple.e50a9cdf.svg";